import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

const AssignTelematicsModal = ({ show, onHide, vehicleCode, onSubmit }) => {
    const [telematicSerialNumber, setTelematicSerialNumber] = useState('');
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (!telematicSerialNumber.trim()) {
            setValidated(true);
            return;
        }

        const payload = {
            vehicleCode,
            telematicSerialNumber: telematicSerialNumber.trim(),
        };

        onSubmit(payload);
        onHide(); // Close modal after submit
        setTelematicSerialNumber('');
        setValidated(false);
    };

    const handleClose = () => {
        onHide();
        setTelematicSerialNumber('');
        setValidated(false);
    };

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Assign Telematics to Vehicle</Modal.Title>
            </Modal.Header>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Modal.Body>
                    <Form.Group controlId="vehicleCode">
                        <Form.Label>Vehicle Code</Form.Label>
                        <Form.Control type="text" value={vehicleCode} disabled readOnly />
                    </Form.Group>

                    <Form.Group controlId="telematicSerialNumber" className="mt-3">
                        <Form.Label>Telematic Serial Number</Form.Label>
                        <Form.Control
                            type="text"
                            value={telematicSerialNumber}
                            onChange={(e) => setTelematicSerialNumber(e.target.value)}
                            required
                            placeholder="Enter serial number"
                        />
                        <Form.Control.Feedback type="invalid">
                            Please provide a valid telematic serial number.
                        </Form.Control.Feedback>
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button variant="primary" type="submit">
                        Assign
                    </Button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default AssignTelematicsModal;
